import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	ccEmployeeOptions: {
		color: '#767676',
		display: 'block',
		fontSize: 14,
	},
	ccEmployeeOptionsInputs: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: THEME.spacing.sm, // Use theme spacing
			},
			':not(:first-child)'
		),
	},
	ccEmployeeSearchField: {
		flexGrow: 1,
		maxWidth: 300,
		minWidth: 200,
	},
	daysInput: {
		textAlign: 'center',
		width: 40,
	},
	followUpReminderLabel: {
		alignItems: 'center',
		display: 'flex',
	},
	option: {
		':not(:first-child)': {
			marginTop: THEME.spacing.sm, // Use theme spacing
		},
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		minHeight: 25,
	},
	sendOnBehalfDisabledWarning: {
		color: '#767676',
		fontSize: 12,
		fontStyle: 'italic',
		maxWidth: 300,
	},
	textInput: {
		margin: `0 ${THEME.spacing.xs}`, // Use theme spacing
		padding: THEME.spacing.xs, // Use theme spacing
	},
	warningMessage: {
		alignItems: 'center',
		display: 'inline-flex',
		marginTop: THEME.spacing.xs, // Use theme spacing
		padding: THEME.spacing.xs, // Use theme spacing
	},
	warningMessageContent: {
		fontSize: 11,
	},
});
